import React from 'react';
import { useAppState } from '../../content-builder-components/ContentBuilderStateProvider.js';
import PolymerAssetType from '../../asset-components/AssetType.js';

function InspectorVideoWell(props) {
    const { setShowAssetLibrary, onAssetSelected, setAssetLibraryTypes } = useAppState();
    var content = "Choose Video";
    const style = {};

    var className = ''
    var accessory = ''

    if (props.src && props.src.split) {
        // style = {
        //     backgroundImage: 'url(' + props.src + ')',
        //     backgroundSize: 'cover'
        // }
        let components = props.src.split('/');
        content = components[components.length - 1];
        
        if (props.title) {
            content = props.title;
        } else {
            content = "Replace"
        }

        accessory = 'Replace'
        className += ' video-filled'
    } else {
        //content = props.src
    }

    const onImageSelectedCallback = (image) => {
        if (props.onImageSelected) {
            props.onImageSelected(image);
        }
    };

    
    return (
        <div className="inspector-video-well" style={{ paddingBottom: "0px" }}
            onClick={() => {
                setAssetLibraryTypes([PolymerAssetType.Video]);
                setShowAssetLibrary(true);
                onAssetSelected.current = onImageSelectedCallback;
            }}>
            <div className={`inspector-video-well-title ${className}`} style={style}>
                <span className='title'>{content}</span>
                <span className='accessory'>{accessory}</span>
            </div>
        </div>
    );
}

export { InspectorVideoWell }
